// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WalletOutlinedSvg from "@fishx/icons-svg/es/asn/WalletOutlined";
import FishxIcon from '../components/FishxIcon';

var WalletOutlined = function WalletOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WalletOutlinedSvg
  }));
};

WalletOutlined.displayName = 'WalletOutlined';
export default React.forwardRef(WalletOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WalletOutlined.js
// module id = 4377
// module chunks = 0